import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Quasar from 'quasar/src/vue-plugin.js';import Loading from 'quasar/src/plugins/loading/Loading.js';
import quasarUserOptions from './quasar-user-options'
import axios from 'axios'

// Despligue local
// axios.defaults.baseURL = "https://localhost:7050/api/"

axios.defaults.baseURL = "https://apisaludencasa.contago.com.mx/api/"

createApp(App).use(Quasar, quasarUserOptions).use(store).use(router).mount('#app')
